import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsMRadlerLinks(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 48.31 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M47.64 7.72H31.76l-1.94-3.97 5.65-.08c1.01-.02 1.81-.83 1.81-1.83V1.8c0-1.01-.85-1.82-1.86-1.81L22.64.17C21.63.19 20.83 1 20.83 2v.04c0 1.02.85 1.83 1.86 1.81l4.37-.06 2.33 4.77-6.1 9.91c-2.31-1.26-4.92-1.9-7.61-1.87-4.16.06-8.05 1.74-10.94 4.72C1.84 24.3.27 28.24.33 32.4c.06 4.16 1.74 8.05 4.72 10.94 2.93 2.85 6.78 4.41 10.85 4.41h.23c4.16-.06 8.05-1.74 10.95-4.72a15.4 15.4 0 0 0 4.38-10.25l9.44-.12c.08 0 .16-.01.24-.03l1.62 3.31c-.71.32-1.21 1.04-1.21 1.86v.04c.02 1.13.95 2.04 2.08 2.02l2.24-.03c1.13 0 2.03-.94 2.03-2.06v-.02a2.055 2.055 0 0 0-2.09-2.02h-.37L32.98 10.22h14.65v-2.5ZM24.09 21.97a13.145 13.145 0 0 1 3.84 5.02c.45 1.06.77 2.17.93 3.33l-9.99.13 5.22-8.48Zm1.2 19.32c-2.43 2.5-5.69 3.91-9.19 3.96-3.52.06-6.79-1.26-9.29-3.7-2.51-2.43-3.92-5.7-3.97-9.19-.05-3.49 1.26-6.79 3.7-9.3 2.43-2.5 5.7-3.91 9.19-3.96h.19c2.15 0 4.22.52 6.07 1.49l-6.44 10.48c-.24.39-.25.88-.02 1.27.22.4.64.64 1.09.64h.01l12.34-.16c-.15 3.18-1.43 6.16-3.68 8.47Zm6.09-11h-.01c-.41-3.53-2.02-6.78-4.6-9.29-.43-.42-.89-.81-1.36-1.18l5.29-8.59 9.25 18.94-8.57.12Z"
        style={{
          fill: '#03657a',
        }}
      />
    </svg>
  )
}
export default SvgMsKlimadashboardIconsMRadlerLinks
